export const CONSTANTS = {
  MAX_VARIATIONS: 2,
  MAX_OPTIONS: 20,
  PAGE_SIZE: 8,
  PAGE_ID: 303
}; 